import React from "react";
import { DataTable } from "primereact/datatable";
import { T } from "services/lang/LanguageService";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import ColorPicker from "components/basic/color-picker/ColorPicker";
import { DatasetChartProps } from "./interfaces";

interface IBarChartIdentifiersEditorProps {
  currentConfig: DatasetChartProps;
  setCurrentConfig: React.Dispatch<React.SetStateAction<DatasetChartProps>>;
}

const BarsIdentifiersEditor = ({
  currentConfig,
  setCurrentConfig,
}: IBarChartIdentifiersEditorProps) => {
  const colorEditor = (options: any) => (
    <ColorPicker
      value={options.value}
      onValueChange={e => options.editorCallback(e.target.value)}
    />
  );

  const colorBodyTemplate = (rowData: any, field: string) => {
    return (
      <div className="flex justify-content-center">
        {field === "color" ? (
          <div
            style={{
              backgroundColor: rowData.color,
              width: "25px",
              height: "25px",
              border: "1px solid black",
            }}
          />
        ) : (
          <div
            style={{
              backgroundColor: rowData.bgColor,
              width: "25px",
              height: "25px",
              border: "1px solid black",
            }}
          />
        )}
      </div>
    );
  };

  const onRowEditComplete = (e: any) => {
    const datasetsToUpdate = [...currentConfig.datasets!];
    const { newData } = e;
    setCurrentConfig({
      ...currentConfig,
      datasets: datasetsToUpdate.map(dataset => {
        if (dataset.identifier === newData.identifier) {
          return { ...dataset, ...newData };
        }
        return dataset;
      }),
    });
  };

  const titleBodyTemplate = (rowData: any) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const textEditor = (options: any) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={e => options.editorCallback(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  };

  const overriddenTitleBodyTemplate = (rowData: any) => {
    return <div>{rowData.overriddenTitle}</div>;
  };

  return (
    <DataTable value={currentConfig.datasets} editMode="row" onRowEditComplete={onRowEditComplete}>
      <Column field={T("word.identifier")} header="Identifier" body={titleBodyTemplate} />
      <Column
        field="overriddenTitle"
        header={T("word.overridden-title")}
        editor={textEditor}
        body={overriddenTitleBodyTemplate}
      />
      <Column
        className="p-0 w-9rem"
        field="color"
        header={T("word.color")}
        align="center"
        editor={colorEditor}
        body={rowData => colorBodyTemplate(rowData, "color")}
      />
      <Column rowEditor />
    </DataTable>
  );
};

export default BarsIdentifiersEditor;
